import React, { Component } from "react"
import {Switch, Route, NavLink} from "react-router-dom"

import {DarePage} from './dare'
import MenuItem from "./components/MenuItem"
import famdy_logo from '../../static/img/rsz_splash2.png';
export class FumdyAdmin extends Component {

    constructor(props) {
        super(props)
        this.state = {
            togle_islaod: false,
        }
    }

    render() {
        return (
            <div className={this.state.togle_islaod ? "toggled" : ""} id="wrapper" >
                <header class="topbar-nav">
                    <nav class="navbar navbar-expand fixed-top bg-white">
                    <ul class="navbar-nav mr-auto align-items-center">
                        <li class="nav-item">
                            <a class="nav-link toggle-menu" onClick={() =>  this.setState(prevState => ({togle_islaod: !prevState.togle_islaod}))}>
                        <i class="icon-menu menu-icon"></i>
                        </a>
                        </li>
                    </ul>
                    </nav>
                </header>
                <div id="sidebar-wrapper" data-simplebar="" data-simplebar-auto-hide="true">
                    <div className="brand-logo">
                        <img style={{borderRadius: "5px"}} src={famdy_logo} className="logo-icon" alt="logo icon"></img>
                        <h5 className="logo-text bolt"> Famdy</h5>
                    </div>
                    <ul className="sidebar-menu do-nicescrol">
                        <MenuItem icon="gp-text-info fa fa-question" url="/mangarfamdygiinadmin/dare/GrandMother/" text="Dare"></MenuItem>
                    </ul>
                </div>
                <div className="content-wrapper">
                    <Switch>
                        <Route path={"/mangarfamdygiinadmin/dare"} component={DarePage}/>
                    </Switch>
                </div>
            </div>
        )

    }

}
